import "./main.scss";
import "./validation/validation.js";

import intlTelInput from "intl-tel-input";
import { initVideoControllers } from "./js/videoController";
import { initDropdown } from "./js/dropdown";
import {
  initModal,
  initRegistrationModal,
  initConnectModal,
  initSendModal,
  initRestoreModal,
  initChangeModal,
} from "./js/modal";
import {
  showSolutionCards,
  showSolutionPageCards,
  showBlogCards,
} from "./js/showCards";
import { initTabs, initTabsAll } from "./js/tabs";
import {
  initAccordion,
  initGlobalAccordion,
  initAccordionProblems,
} from "./js/accordion";
import { initSwiper, initTariffsSwiper } from "./js/swiper";
import { handleBurger } from "./js/burger";
import { initIntlTel } from "./js/intlTel";
import { initSwiperNews } from "./js/swiperNews";
import { initSearch } from "./js/search";
import { initHeaderScroll } from "./js/scrollHeader";
import { showFunctionalCards } from "./js/functionalCards";
import { initSort } from "./js/sort.js";
import { initPagination } from "./js/pagination.js";
import { initNumberAnimation } from "./js/animateNumber.js";
import { initSwitchBtn } from "./js/switchBtn.js";
import { initShowMore } from "./js/showMore.js";
import { initDocumentCards } from "./js/documentCards.js";
import {
  createSidebarList,
  initSidebarDropdown,
} from "./js/createSidebarList.js";
import { loadItems } from "./js/loadItems.js";
import { searchInputHandler, wikiSearch } from "./js/searchHandler.js";
import { playVideo } from "./js/playVideo.js";
import { toggleMobileSubmenu } from "./js/toggleMobileSubmenu.js";

document.addEventListener("DOMContentLoaded", () => {
  searchInputHandler();
  const swiper = initSwiper(); //swiper in business section (main-page)
  const itis = initIntlTel(); //plagin intl-tel-input

  // modals
  initChangeModal(); //modal with change password
  initConnectModal(); //modal with connect-form
  initModal(); //modal with login-form
  initRegistrationModal(); //modal with registration-form
  initRestoreModal(); //modal  with restore password
  initSendModal(); //modal with sibscribe in footer

  // show cards
  showBlogCards(); // show more cards (blog-page)
  showFunctionalCards(); //show more cards (functional-page)
  showSolutionCards(); //show more cards (main-page)
  showSolutionPageCards(); //show more cards (solution-page)

  createSidebarList(); //sidebar-list (article-page)
  handleBurger(); //burger in header
  initAccordion(swiper); // accordion in business section (main-page)
  initAccordionProblems(); //accordion in problems-section (automatization-page)
  initDropdown(); //dropdown in possibilities section  (main-page)
  initHeaderScroll(); //  header behavior when scrolling
  initNumberAnimation(); //number animation (company-page)
  initPagination(); // pagination (blog-page)
  initSearch(); // search input in header
  initSidebarDropdown(); // toggle sidebar-list (article-page)
  initSort(); //sorting  (blog-page)
  initSwiperNews(); //swiper in news section (main-page)
  initTabs(); // tabs in solution section (main-page)
  initTabsAll(); // tabs (shared)
  initTariffsSwiper(); //swiper in the tariffs section (tariffs-page)
  initVideoControllers(); //controllers in banner (main-page and company-page)
  initSwitchBtn(); //switcher
  initShowMore(); //
  initDocumentCards(); // opening cards (support-variants-page)
  initGlobalAccordion(); // universal accordion
  loadItems(); //loading items (wiki-child-page)
  playVideo(); // playing video (article-page)
  toggleMobileSubmenu(); //toggle submenu (header)
  wikiSearch();
});
